// import React from 'react';
// import Grid from '@mui/material/Grid';
// import { Typography } from "@mui/material";

// const FooterContent = () => {
//     return (
//         <Grid container spacing={0} minHeight={'60px'}
//             justifyContent="center" height={'100%'}
//             alignItems="center" className={'fancyBackground'}>
//             <Grid item xs={12} md={4}>
//                 <Typography fontSize={'small'} align={'center'}>Copyright Energy Home System
//                     @{new Date().getFullYear()} All rights reserved</Typography>
//             </Grid>

//             <Grid item xs={12} md={7}>
//                 <Typography fontSize={'small'} align={'center'}>
//                     Designed to make your home smarter and your life easier, helping you save energy and lower your costs!
//                 </Typography>
//             </Grid>
//         </Grid>
//     );
// }

// export default FooterContent;

import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const FooterContent = () => {
    return (
        <Container maxWidth={'xl'}>
            <Grid container spacing={0}
                alignItems="center" justifyItems={'center'}>
                <Grid item xs={12} md={4}>
                    <Typography fontSize="small">
                        {`Copyright Hedge-IoT Consortium @${new Date().getFullYear()} `}
                        All rights reserved
                    </Typography>
                </Grid>

                <Grid item xs={12} md={2} alignItems="center" justifyContent={'center'} justifyItems={'center'}
                    sx={{ py: 1 }}>
                    <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                    >
                        <img src="/images/ec_logo.svg" alt="" height={'44px'} />
                    </Box>
                </Grid>

                <Grid item xs={12} md={6}>
                    <Typography fontSize={'small'}
                        alignContent={'center'}>{'Co-funded by the European Union under Grant Agreement no. 101136216.'}</Typography>
                </Grid>
            </Grid>
        </Container>
    );
}

export default FooterContent;